module.exports = __webpack_public_path__ + "static/media/006_g1-5More options menu.34a56109.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/gigable/006_g1-5More options menu.png
// module id = 433
// module chunks = 0